import axios from 'axios';
import { API_BASE_URL } from '@/config/serverApiConfig';

import errorHandler from './errorHandler';
import successHandler from './successHandler';


const axiosInstance = axios.create({
    baseURL: API_BASE_URL,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
        'ngrok-skip-browser-warning': 'true',
    }
});
const mapAxiosInstance = axios.create({
  baseURL: "https://maps.googleapis.com/maps/api/place/autocomplete/json",
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});
const buildQueryString = (options = {}) => {
  const params = new URLSearchParams();
  Object.entries(options || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    params.append(key, value);
  });
  const query = params.toString();
  return query ? `?${query}` : "";
};
const request = {
  create: async ({ createURL, jsonData }) => {
    try {
      let strToken = window.localStorage.getItem("strToken");
      const response = await axiosInstance.post(createURL, jsonData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: strToken,
        },
      });
      successHandler(response, {
        notifyOnSuccess: true,
        notifyOnFailed: true,
      });
      return response.data;
    } catch (error) {
      return errorHandler(error);
    }
  },
  read: async ({ entity, id }) => {
    try {
      const response = await axiosInstance.get(entity + "/read/" + id);
      successHandler(response, {
        notifyOnSuccess: false,
        notifyOnFailed: true,
      });
      return response.data;
    } catch (error) {
      return errorHandler(error);
    }
  },
  fileUpload: async ({ createURL, jsonData, privateKey = null }) => {
    
    try {
      let strToken = window.localStorage.getItem("strToken");
      const headers = {
        Authorization: strToken,
      };
      if (privateKey) {
        headers["private-key"] = privateKey;
        delete headers["Authorization"];
      }
      const response = await axiosInstance.post(createURL, jsonData, {
        headers,
      });
      successHandler(response, {
        notifyOnSuccess: true,
        notifyOnFailed: true,
      });
      return response.data;
    } catch (error) {
      return errorHandler(error);
    }
  },
  update: async ({ entity, id, jsonData }) => {


    try {
      const response = await axiosInstance.patch(
        entity + "/update/" + id,
        jsonData
      );
      successHandler(response, {
        notifyOnSuccess: true,
        notifyOnFailed: true,
      });
      return response.data;
    } catch (error) {
      return errorHandler(error);
    }
  },

  delete: async ({ entity, id, options = {} }) => {
    try {
      const response = await axiosInstance.delete(entity + "/delete/" + id);
      successHandler(response, {
        notifyOnSuccess: true,
        notifyOnFailed: true,
      });
      return response.data;
    } catch (error) {
      return errorHandler(error);
    }
  },

  filter: async ({ entity, options = {} }) => {
    try {
      let filter = options.filter ? "filter=" + options.filter : "";
      let equal = options.equal ? "&equal=" + options.equal : "";
      let query = `?${filter}${equal}`;

      const response = await axiosInstance.get(entity + "/filter" + query);
      successHandler(response, {
        notifyOnSuccess: false,
        notifyOnFailed: false,
      });
      return response.data;
    } catch (error) {
      return errorHandler(error);
    }
  },

  search: async ({ entity, options = {} }) => {
    try {
      let query = "?";
      for (var key in options) {
        query += key + "=" + options[key] + "&";
      }
      query = query.slice(0, -1);
      // headersInstance.cancelToken = source.token;
      const response = await axiosInstance.get(entity + "/search" + query);

      successHandler(response, {
        notifyOnSuccess: false,
        notifyOnFailed: false,
      });
      return response.data;
    } catch (error) {
      return errorHandler(error);
    }
  },

  list: async ({ listURL, options = {}, headers = {} }) => {
    try {
      let strToken = window.localStorage.getItem("strToken");
      const response = await axiosInstance.post(listURL, options, {
        headers: {
          "Content-Type": "application/json",
          Authorization: strToken,
          ...(headers || {}),
        },
      });

      successHandler(response, {
        notifyOnSuccess: false,
        notifyOnFailed: false,
      });
      return response.data;
    } catch (error) {
      return errorHandler(error);
    }
  },
  get: async ({ getURL, options = {} }) => {
    try {
      let strToken = window.localStorage.getItem("strToken");
      const query = buildQueryString(options);
      const response = await axiosInstance.get(`${getURL}${query}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: strToken,
        },
      });

      successHandler(response, {
        notifyOnSuccess: false,
        notifyOnFailed: false,
      });
      return response.data;
    } catch (error) {
      return errorHandler(error);
    }
  },
  getAllTypeList: async ({ strListType, strType, type = "allTypes" }) => {
    try {
      let strToken = window.localStorage.getItem("strToken");
      const response = await axiosInstance.post(
        "get_type_list",
        {
          strType,
          type,
          strListType,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: strToken,
          },
        }
      );
      successHandler(response, {
        notifyOnSuccess: false,
        notifyOnFailed: false,
      });
      return response.data;
    } catch (error) {
      return errorHandler(error);
    }
  },
  commonTypeList: async ({ strListType, strType, type = "allTypes" }) => {
    try {
      let strToken = window.localStorage.getItem("strToken");
      const response = await axiosInstance.post(
        "common_list",
        {
          strType,
          type,
          strListType,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: strToken,
          },
        }
      );
      successHandler(response, {
        notifyOnSuccess: false,
        notifyOnFailed: false,
      });
      return response.data;
    } catch (error) {
      return errorHandler(error);
    }
  },
  post: async ({ entity, jsonData, options = {} }) => {
    try {
      const response = await axiosInstance.post(entity, jsonData);

      return response.data;
    } catch (error) {
      return errorHandler(error);
    }
  },

  map_autocomplete: async ({ entity, params }) => {
    try {
      const response = await mapAxiosInstance.get("", params);
      // successHandler(response, {
      //   notifyOnSuccess: true,
      //   notifyOnFailed: true,
      // });
      return response.data;
    } catch (error) {
      return errorHandler(error);
    }
  },
  // get: async ({ entity,jsonData,options={} }) => {
  //   try {
  //     const response = await axiosInstance.get(entity,jsonData,options);
  //     return response.data;
  //   } catch (error) {
  //     return errorHandler(error);
  //   }
  // },
  get: async ({ listURL, options = {} }) => {
    try {
      let strToken = await window.localStorage.getItem("strToken");
      const response = await axiosInstance.post(listURL, options, {
        headers: {
          "Content-Type": "application/json",
          Authorization: strToken,
        },
      });

      successHandler(response, {
        notifyOnSuccess: false,
        notifyOnFailed: false,
      });

      return response.data;
    } catch (error) {
      return errorHandler(error);
    }
  },
  getRequest: async ({ url, params = {}, headers = {}, timeout }) => {
    try {
      let strToken = await window.localStorage.getItem("strToken");
      const response = await axiosInstance.get(url, {
        params,
        ...(timeout != null ? { timeout } : {}),
        headers: {
          "Content-Type": "application/json",
          Authorization: strToken,
          ...(headers || {}),
        },
      });
      successHandler(response, {
        notifyOnSuccess: false,
        notifyOnFailed: false,
      });
      return response.data;
    } catch (error) {
      return errorHandler(error);
    }
  },
  deleteRequest: async ({ url, params = {} }) => {
    try {
      let strToken = await window.localStorage.getItem("strToken");
      const response = await axiosInstance.delete(url, {
        params,
        headers: {
          "Content-Type": "application/json",
          Authorization: strToken,
        },
      });
      successHandler(response, {
        notifyOnSuccess: false,
        notifyOnFailed: false,
      });
      return response.data;
    } catch (error) {
      return errorHandler(error);
    }
  },
  download: async ({ url, params = {}, responseType = "blob" }) => {
    try {
      let strToken = await window.localStorage.getItem("strToken");
      const response = await axiosInstance.get(url, {
        params,
        responseType,
        headers: {
          Authorization: strToken,
        },
      });
      return response;
    } catch (error) {
      return errorHandler(error);
    }
  },
  patch: async ({ entity, jsonData }) => {
    try {
      const response = await axiosInstance.patch(entity, jsonData);
      successHandler(response, {
        notifyOnSuccess: true,
        notifyOnFailed: true,
      });
      return response.data;
    } catch (error) {
      return errorHandler(error);
    }
  },
  putRequest: async ({ url, jsonData = {} }) => {
    try {
      let strToken = window.localStorage.getItem("strToken");
      const response = await axiosInstance.put(url, jsonData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: strToken,
        },
      });
      successHandler(response, {
        notifyOnSuccess: true,
        notifyOnFailed: true,
      });
      return response.data;
    } catch (error) {
      return errorHandler(error);
    }
  },
  upload: async ({ uploadURL, formData }) => {
    try {
      let strToken = window.localStorage.getItem("strToken");
      const response = await axiosInstance.post(uploadURL, formData, {
        headers: {
          Authorization: strToken,
          // Content-Type omitted — axios sets multipart/form-data with boundary automatically
        },
      });
      successHandler(response, {
        notifyOnSuccess: false,
        notifyOnFailed: true,
      });
      return response.data;
    } catch (error) {
      return errorHandler(error);
    }
  },

  source: () => {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    return source;
  },
};
export default request;
